export default {
	POLL_CREATE: 'POLL_CREATE',
	POLL_REMOVE: 'POLL_REMOVE',
	POLL_UPDATE: 'POLL_UPDATE',
	POLL_UPDATED: 'POLL_UPDATED',
	RESULTS_UPDATED: 'RESULTS_UPDATED',
	SIGN_IN_HIDE: 'SIGN_IN_HIDE',
	SIGN_IN_SHOW: 'SIGN_IN_SHOW',
	SIGN_IN: 'SIGN_IN',
	SIGN_IN_RESULT: 'SIGN_IN_RESULT',
	SIGN_OUT: 'SIGN_OUT',
	USER_UPDATED: 'USER_UPDATED',
	VOTE_CAST: 'VOTE_CAST',
	VOTE_READ: 'VOTE_READ',
}



// WEBPACK FOOTER //
// ./src/redux/actions/types.js